import type { UserProfileType } from '@3plearning/mx-teacher-analytics';

import { QueryParams } from '@config/react-router-dom/hooks/query-params.types';

const mapUserProfileType = (type: string): UserProfileType => {
    switch (type) {
    case '2':
        return 'teacher';
    case '3':
        return 'admin';
    default:
        return 'unknown';
    }
};

export const buildIdentityProps = (
    queryParams: URLSearchParams,
    locale: string
) => ({
    locale,
    countryCode: queryParams.get(QueryParams.countryCode) ?? '',
    userProfileId: queryParams.get(QueryParams.userProfileId) ?? '',
    userProfileType: mapUserProfileType(queryParams.get(QueryParams.userProfileType) ?? ''),
    marketRegionId: queryParams.get(QueryParams.marketRegionId) ?? '',
    schoolId: queryParams.get(QueryParams.schoolId) ?? '',
    oneRosterUserId: queryParams.get(QueryParams.oneRosterUserId) ?? ''
});
